import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('plan', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.000000)",
    fill: props.colors[0]
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5587,6.70466 C12.7371,6.49386 12.7108,6.17837 12.5,6 C12.2892,5.82163 11.9737,5.84792 11.7953,6.05872 L6.93886,11.7982 L4.7042,9.936 C4.49206,9.7592 4.17678,9.7879 4,10 C3.82322,10.2121 3.85188,10.5274 4.06402,10.7042 L6.67991,12.8841 C6.89092,13.06 7.20427,13.0327 7.38169,12.823 L12.5587,6.70466 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0.5 C4,0.22386 4.22386,0 4.5,0 C4.77614,0 5,0.22386 5,0.5 L5,2 L11,2 L11,0.5 C11,0.22386 11.2239,0 11.5,0 C11.7761,0 12,0.22386 12,0.5 L12,2 L15,2 C15.5523,2 16,2.44772 16,3 L16,16 C16,16.5523 15.5523,17 15,17 L1,17 C0.44772,17 0,16.5523 0,16 L0,3 C0,2.44772 0.44772,2 1,2 L4,2 L4,0.5 Z M1.5,3 C1.22386,3 1,3.22386 1,3.5 L1,15.5 C1,15.7761 1.22386,16 1.5,16 L14.5,16 C14.7761,16 15,15.7761 15,15.5 L15,3.5 C15,3.22386 14.7761,3 14.5,3 L1.5,3 Z"
  })))));
});